var Direction = /* @__PURE__ */ ((Direction2) => {
  Direction2["column"] = "column";
  Direction2["row"] = "row";
  Direction2["rowReverse"] = "row-reverse";
  Direction2["columnReverse"] = "column-reverse";
  return Direction2;
})(Direction || {});
export {
  Direction
};
//# sourceMappingURL=direction.es.js.map
